import { Quote, Star } from "lucide-react";

const testimonials = [
  {
    name: "Budi Santoso",
    role: "Owner Workshop Signage",
    city: "Surabaya",
    initials: "BS",
    rating: 5,
    quote: "Kualitas acrylic ANIMAX konsisten dari batch ke batch. Kejernihannya premium, cocok untuk huruf timbul dan signage klien kami. Pengiriman ke Surabaya juga selalu tepat waktu.",
  },
  {
    name: "Dewi Kartika",
    role: "Interior Designer",
    city: "Jakarta",
    initials: "DK",
    rating: 5,
    quote: "Sudah beberapa proyek residensial saya pakai ANIMAX untuk partisi dan aksen furniture. Warnanya solid, permukaannya halus, dan tim mereka responsif saat konsultasi spesifikasi.",
  },
  {
    name: "Ahmad Rizki",
    role: "Kontraktor Proyek",
    city: "Malang",
    initials: "AR",
    rating: 5,
    quote: "Order kami skala besar untuk proyek retail. ANIMAX bisa handle volume, packaging aman sampai lokasi, dan harganya sangat kompetitif untuk kualitas ini. Rekomended.",
  },
  {
    name: "Siti Rahmawati",
    role: "Distributor Bahan Bangunan",
    city: "Semarang",
    initials: "SR",
    rating: 5,
    quote: "Sebagai distributor, saya butuh supplier yang stabil dan bisa dipercaya. PT. Animax Putra Lancar memberikan itu — stok tersedia, komunikasi lancar, dan mitra jangka panjang.",
  },
  {
    name: "Yoga Pratama",
    role: "Pemilik Laser Cutting Service",
    city: "Yogyakarta",
    initials: "YP",
    rating: 5,
    quote: "Untuk laser cutting, kejernihan tepi hasil potong sangat menentukan. ANIMAX memberikan hasil potong yang bersih tanpa gelembung. Sudah jadi pilihan utama workshop kami.",
  },
  {
    name: "Linda Wijaya",
    role: "Owner Display Store",
    city: "Bandung",
    initials: "LW",
    rating: 5,
    quote: "Display etalase toko kami pakai ANIMAX Acrylic. Sudah 2 tahun terpasang di outdoor, tetap jernih dan tidak menguning. UV protection-nya memang bekerja.",
  },
];

export const Testimonials = () => {
  return (
    <section id="testimoni" data-testid="testimonials-section" className="py-24 lg:py-32 bg-white relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-animax-yellow/5 blur-[120px]" />

      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div className="max-w-2xl">
            <div className="tag-uppercase text-animax-orange mb-4">Testimoni Customer</div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-animax-black leading-tight">
              Dipercaya oleh Profesional di Seluruh Indonesia
            </h2>
          </div>
          <div className="flex items-center gap-6">
            <div>
              <div className="flex items-center gap-1">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-animax-yellow text-animax-yellow" />
                ))}
              </div>
              <div className="mt-2 text-sm text-neutral-600">Rating 4.9/5 dari mitra kami</div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <article
              key={i}
              data-testid={`testimonial-${i}`}
              className="card-lift group p-8 rounded-2xl bg-white border border-neutral-200 hover:border-animax-orange/40 relative"
            >
              <Quote className="absolute top-6 right-6 w-8 h-8 text-animax-yellow/30 group-hover:text-animax-yellow transition-colors" />

              <div className="flex items-center gap-1 mb-4">
                {[...Array(t.rating)].map((_, s) => (
                  <Star key={s} className="w-3.5 h-3.5 fill-animax-yellow text-animax-yellow" />
                ))}
              </div>

              <p className="text-sm text-neutral-700 leading-relaxed">&ldquo;{t.quote}&rdquo;</p>

              <div className="mt-6 pt-6 border-t border-neutral-100 flex items-center gap-3">
                <div className="w-11 h-11 rounded-full bg-gradient-to-br from-animax-yellow to-animax-orange flex items-center justify-center text-animax-black font-display font-semibold text-sm">
                  {t.initials}
                </div>
                <div>
                  <div className="font-medium text-animax-black text-sm">{t.name}</div>
                  <div className="text-xs text-neutral-500">{t.role} · {t.city}</div>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-8">
          {[
            { label: "Rating Kepuasan", value: "4.9/5" },
            { label: "Mitra Aktif", value: "50+" },
            { label: "Kota Pengiriman", value: "15+" },
            { label: "Repeat Order", value: "90%" },
          ].map((s, i) => (
            <div key={i} className="text-center px-6" data-testid={`testimonial-stat-${i}`}>
              <div className="font-display text-3xl lg:text-4xl font-medium text-animax-black">{s.value}</div>
              <div className="tag-uppercase text-neutral-500 mt-1">{s.label}</div>
            </div>
          ))}
        </div>

        <p className="mt-8 text-center text-sm text-neutral-600" data-testid="testimonial-shipping-note">
          Melayani pengiriman ke <strong className="text-animax-black">seluruh Indonesia</strong>
        </p>
      </div>
    </section>
  );
};
